// src/uteis/mascaras/mascaraTelefone.js

/**
 * Aplica máscara ao número de telefone no formato (99) 99999-9999
 * Aceita entrada parcial.
 */
export function aplicarMascaraTelefone(valor) {
    const apenasNumeros = valor.replace(/\D/g, '');
  
    if (apenasNumeros.length <= 2) {
      return `(${apenasNumeros}`;
    } else if (apenasNumeros.length <= 7) {
      return `(${apenasNumeros.slice(0, 2)}) ${apenasNumeros.slice(2)}`;
    } else if (apenasNumeros.length <= 11) {
      return `(${apenasNumeros.slice(0, 2)}) ${apenasNumeros.slice(2, 7)}-${apenasNumeros.slice(7)}`;
    } else {
      return `(${apenasNumeros.slice(0, 2)}) ${apenasNumeros.slice(2, 7)}-${apenasNumeros.slice(7, 11)}`;
    }
  }
  